const { API_ENV } = process.env

if (API_ENV === 'developer' || API_ENV === 'local') {
  module.exports = require('./configureStore.dev')
} else {
  module.exports = require('./configureStore.prod')
}
